import { render, staticRenderFns } from "./SsoTenantListe.vue?vue&type=template&id=a1dcbe82"
import script from "./SsoTenantListe.vue?vue&type=script&lang=js"
export * from "./SsoTenantListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports